'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactRouter = require('react-router');

var _utilsPagination = require('@bibliocommons/utils-pagination');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseButtons = require('@bibliocommons/base-buttons');

var _baseIcons = require('@bibliocommons/base-icons');

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

require('../styles/Pagination.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Pagination = function (_BcReactComponent) {
  _inherits(Pagination, _BcReactComponent);

  function Pagination(props) {
    _classCallCheck(this, Pagination);

    var _this = _possibleConstructorReturn(this, (Pagination.__proto__ || Object.getPrototypeOf(Pagination)).call(this, props));

    _this.bindAll('handleNextClick', 'handlePrevClick', 'handlePaginationNumberClick');
    return _this;
  }

  _createClass(Pagination, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var autoFocus = this.props.autoFocus;
      // if element allows autofocus && a fetch has completed && the results/route have changed

      if (autoFocus && this.hasChanged(prevProps)) {
        this.focusResultsCount();
      }
    }
  }, {
    key: 'hasChanged',
    value: function hasChanged(prevProps) {
      var _props = this.props,
          limit = _props.limit,
          page = _props.page,
          pages = _props.pages,
          count = _props.count,
          router = _props.router;

      return prevProps.limit !== limit || prevProps.page !== page || prevProps.pages !== pages || prevProps.count !== count || prevProps.router.location !== router.location;
    }
  }, {
    key: 'focusResultsCount',
    value: function focusResultsCount() {
      if (this._resultsCount) {
        this._resultsCount.focus();
      }
    }
  }, {
    key: 'updatePage',
    value: function updatePage(page) {
      if (this.props.updatePage) {
        return this.props.updatePage(page);
      }

      return this.props.router.push(this.getHrefForPage(page));
    }
  }, {
    key: 'getHrefForPage',
    value: function getHrefForPage(page) {
      var _props$router = this.props.router,
          createHref = _props$router.createHref,
          location = _props$router.location;

      return createHref(_extends({}, location, { query: _extends({}, location.query, _defineProperty({}, this.props.queryField, page)) }));
    }
  }, {
    key: 'handlePaginationNumberClick',
    value: function handlePaginationNumberClick(e) {
      this.updatePage(parseInt(e.currentTarget.getAttribute('data-page'), 10));
    }
  }, {
    key: 'renderScreenReaderTextForPage',
    value: function renderScreenReaderTextForPage(page) {
      return _react2.default.createElement(
        _baseScreenReaderMessage2.default,
        null,
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Search.jumpToPage', values: { page: page, isCurrentPage: page === this.props.page ? 'yes' : 'no' } })
      );
    }
  }, {
    key: 'renderPageNumbers',
    value: function renderPageNumbers() {
      var _this2 = this;

      return _lodash2.default.map((0, _utilsPagination.pageRange)(this.props.page, this.props.pages), function (i) {
        var isCurrentPage = _this2.props.page === i;
        var isDisabled = _this2.props.isFetching || isCurrentPage;
        var classString = isCurrentPage ? 'current-page' : 'btn-link';

        return _react2.default.createElement(
          'li',
          { key: i, className: isDisabled ? 'disabled' : '' },
          _react2.default.createElement(
            _baseButtons.Button,
            {
              dataKey: 'page-link',
              className: classString,
              href: _this2.getHrefForPage(i),
              tagName: isDisabled ? 'button' : 'a',
              flat: true,
              disabled: isDisabled,
              'data-page': i,
              'aria-disabled': isDisabled,
              handleClick: _this2.handlePaginationNumberClick },
            _react2.default.createElement(
              'span',
              { 'aria-hidden': true },
              i
            ),
            _this2.renderScreenReaderTextForPage(i)
          )
        );
      });
    }
  }, {
    key: 'handleNextClick',
    value: function handleNextClick() {
      this.updatePage(this.props.page + 1);
    }
  }, {
    key: 'handlePrevClick',
    value: function handlePrevClick() {
      this.updatePage(this.props.page - 1);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          page = _props2.page,
          pages = _props2.pages,
          isFetching = _props2.isFetching,
          limit = _props2.limit,
          count = _props2.count,
          className = _props2.className,
          showPages = _props2.showPages,
          textKey = _props2.textKey;

      var startIndex = (page - 1) * limit + 1;
      var endIndex = _lodash2.default.min([page * limit, count]);
      var previousDisabled = isFetching || (0, _utilsPagination.isPreviousDisabled)(page, pages);
      var nextDisabled = isFetching || (0, _utilsPagination.isNextDisabled)(page, pages);

      return _react2.default.createElement(
        'div',
        { className: 'cp-pagination ' + className, 'data-key': 'pagination-component' },
        _react2.default.createElement(
          _reactIntl.FormattedMessage,
          { id: textKey, values: { start: startIndex, end: endIndex, count: count } },
          function (message) {
            return _react2.default.createElement(
              'span',
              { 'data-key': 'pagination-text', className: 'pagination-text', tabIndex: '-1', ref: function ref(el) {
                  _this3._resultsCount = el;
                } },
              message
            );
          }
        ),
        _react2.default.createElement(
          'ul',
          { className: 'btn-group', role: 'group' },
          _react2.default.createElement(
            'li',
            { className: previousDisabled ? 'disabled' : '' },
            _react2.default.createElement(
              _baseButtons.DefaultButton,
              {
                dataKey: 'previous-btn',
                className: 'previous-btn',
                flat: true,
                disabled: previousDisabled,
                'aria-disabled': previousDisabled,
                handleClick: this.handlePrevClick,
                href: this.getHrefForPage(page - 1),
                tagName: previousDisabled ? 'button' : 'a' },
              _react2.default.createElement(_baseIcons.Angle.Left, { className: 'extra-extra-small' }),
              this.renderScreenReaderTextForPage(page - 1)
            )
          ),
          showPages ? this.renderPageNumbers() : null,
          _react2.default.createElement(
            'li',
            { className: nextDisabled ? 'disabled' : '' },
            _react2.default.createElement(
              _baseButtons.DefaultButton,
              {
                dataKey: 'next-btn',
                className: 'next-btn',
                flat: true,
                disabled: nextDisabled,
                'aria-disabled': nextDisabled,
                handleClick: this.handleNextClick,
                href: this.getHrefForPage(page + 1),
                tagName: nextDisabled ? 'button' : 'a' },
              _react2.default.createElement(_baseIcons.Angle.Right, { className: 'extra-extra-small' }),
              this.renderScreenReaderTextForPage(page + 1)
            )
          )
        )
      );
    }
  }]);

  return Pagination;
}(_baseBcReactComponent2.default);

Pagination.propTypes = {
  page: _react.PropTypes.number.isRequired,
  pages: _react.PropTypes.number.isRequired,
  textKey: _react.PropTypes.string,
  updatePage: _react.PropTypes.func,
  autoFocus: _react.PropTypes.bool,
  isFetching: _react.PropTypes.bool.isRequired,
  showPages: _react.PropTypes.bool,
  limit: _react.PropTypes.number,
  count: _react.PropTypes.number,
  className: _react.PropTypes.string,
  queryField: _react.PropTypes.string
};

Pagination.defaultProps = {
  textKey: 'paginationInfo',
  queryField: 'page',
  className: ''
};

// We need the withRefs so we can access the pagination count and focus it in the outer components
exports.default = (0, _reactRouter.withRouter)(Pagination, { withRef: true });


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/pagination/lib/components/Pagination.component.js
// module id = 1443
// module chunks = 1